__turbopack_context__.v({
  "banner": "CategoryBanner-module-scss-module__Ej8qIq__banner",
  "banner--category": "CategoryBanner-module-scss-module__Ej8qIq__banner--category",
  "banner--subcategory": "CategoryBanner-module-scss-module__Ej8qIq__banner--subcategory",
  "banner--with-image": "CategoryBanner-module-scss-module__Ej8qIq__banner--with-image",
  "banner__art": "CategoryBanner-module-scss-module__Ej8qIq__banner__art",
  "banner__canvas": "CategoryBanner-module-scss-module__Ej8qIq__banner__canvas",
  "banner__copy": "CategoryBanner-module-scss-module__Ej8qIq__banner__copy",
  "banner__description": "CategoryBanner-module-scss-module__Ej8qIq__banner__description",
  "banner__eyebrow": "CategoryBanner-module-scss-module__Ej8qIq__banner__eyebrow",
  "banner__header": "CategoryBanner-module-scss-module__Ej8qIq__banner__header",
  "banner__headline": "CategoryBanner-module-scss-module__Ej8qIq__banner__headline",
  "banner__hero": "CategoryBanner-module-scss-module__Ej8qIq__banner__hero",
  "banner__hero--display-lg": "CategoryBanner-module-scss-module__Ej8qIq__banner__hero--display-lg",
  "banner__hero--display-md": "CategoryBanner-module-scss-module__Ej8qIq__banner__hero--display-md",
  "banner__hero--display-sm": "CategoryBanner-module-scss-module__Ej8qIq__banner__hero--display-sm",
  "banner__image": "CategoryBanner-module-scss-module__Ej8qIq__banner__image",
  "banner__inner": "CategoryBanner-module-scss-module__Ej8qIq__banner__inner",
  "banner__line": "CategoryBanner-module-scss-module__Ej8qIq__banner__line",
  "banner__line--back": "CategoryBanner-module-scss-module__Ej8qIq__banner__line--back",
  "banner__line--front": "CategoryBanner-module-scss-module__Ej8qIq__banner__line--front",
});
